import APIV5 from '~/models/api';
import templateModalWfHistory from '~/components/wf/modal/modal-wf-history.html';
import ModalWfHistoryController from '~/components/wf/modal/modal-wf-history.controller';
import WorkflowService from '~/scripts/services/workflow.service';
import WorkflowAffect from '~/scripts/services/model/workflow-affect';

/* globals Knitiv */

export default class WfAffectListContentController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ISCEService} $sce
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} Notification
	 */
	constructor(
		$injector,
		$filter,
		$location,
		$rootScope,
		$sce,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		Notification,
	) {
		this.$injector = $injector;
		this.$filter = $filter;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$sce = $sce;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.Notification = Notification;

		/** @type {import('~/scripts/services/model/workflow-affect').default[]} */
		this.affectList = [];

		/** @type {any[] | undefined} */
		this.data = undefined;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {boolean} */
		this.isAdminWF = false;

		/** @type {?import('~/components/kform/kform.controller').default} */
		this.kform = null;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;

		/** @type {any[]} */
		this.modelActions = [];

		/** @type {any} */
		this.options = {};

		/** @type {import('~/scripts/services/model/workflow-affect').default[]} */
		this.selected = [];

		/** @type {boolean} */
		this.showAddWorkflow = false;

		this.workflowService = new WorkflowService($injector);

		/** @type {import('~/components/wf/affect/list/wf-affect-list.controller').default | undefined} */
		this.wfAffectList = undefined;
	}

	cancelAddWorkflow() {
		if (this.data?.length === 0) {
			this.showAddWorkflow = false;
		}
		else if (this.data) {
			this.data.pop();
			if (this.data.length === 0) {
				this.showAddWorkflow = false;
			}
		}
	}

	/**
	 * @param {import('~/scripts/services/model/workflow-affect').default} affect
	 * @returns {any}
	 */
	checkUser(affect) {
		return affect.allocatorTo.some((/** @type {any} */ a) => a.kid === this.$rootScope.context?.profil.kid);
	}

	async list() {
		if (this.kid !== null) {
			const affectList = await this.workflowService.nodeAffectList(this.kid, this.options.id);
			if (Array.isArray(affectList)) {
				this.affectList = affectList.map(affect => new WorkflowAffect(affect));
			}
			this.$timeout(() => this.$scope.$apply());
		}
	}

	async openModalHistory(affect = null) {
		try {
			await this.$uibModal.open({
				template:     templateModalWfHistory,
				controller:   ModalWfHistoryController,
				controllerAs: '$ctrl',
				resolve:      {
					affectList: () => (affect ? [affect] : this.selected),
				},
				size:         'full-with-footer',
			}).result;
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
		}
	}

	/**
	 * @param {any} job
	 * @returns {any}
	 */
	openJob(job) {
		if (this.kform?.options.modal) {
			this.kform.options.modal.dismiss();
		}
		return this.$location.path(`/workflow/${job.kid}`);
	}

	/**
	 * @param {any} job
	 */
	async subscriptionSet(job) {
		const jobs = job ? [job] : this.selected;
		for (const job2 of jobs) {
			await APIV5.instance.wfSubscriptionSet({ objnum: job2.kid });
			this.Notification.info({
				title:   this.$translate.instant('common.info'),
				message: this.$translate.instant('workflow.successful-subscription'),
			});
		}
	}

	$onInit() {
		if (!Array.isArray(this.modelActions)) {
			this.modelActions = [];
		}

		if (this.wfAffectList) {
			this.showAddWorkflow = this.wfAffectList.showAddWorkflow;
		}
		else if (this.modelActions.length > 0) {
			this.showAddWorkflow = true;
		}

		if (this.kform && !this.kform.forms[this.kform.currentKid].create) {
			this.kid = this.kform.currentKid;
		}

		if (!this.wfAffectList) {
			(async() => this.list())();
		}

		this.isAdminWF = this.$rootScope.context?.role.mode === 'ADMIN_SUPER'
			|| this.$rootScope.context?.role.sql_in.includes('K_NODE;KR_ADMIN_WF')
			|| false;
	}
}
